import type {
  Command,
  FieldUpdate,
  NewTask,
  ProjectPath,
  RecurrenceSpec,
  SeriesScope,
  TaskId,
  TaskPatch,
  When,
} from "../api/generated";

export function newId(): string {
  return crypto.randomUUID();
}

export function keep<T>(): FieldUpdate<T> {
  return "Keep";
}

/** `null` rather than `undefined` so the clear survives JSON on the way to the Tauri shell. */
export function clearDate(): FieldUpdate<When | undefined> {
  return { Set: null as unknown as undefined };
}

export function setDate(when: When): FieldUpdate<When | undefined> {
  return { Set: when };
}

export function parseProjectPath(text: string): ProjectPath {
  return text
    .split("/")
    .map((segment) => segment.trim())
    .filter((segment) => segment !== "");
}

export function formatProjectPath(path: ProjectPath): string {
  return path.join("/");
}

export function editCommand(
  id: TaskId,
  patch: TaskPatch,
  scope: SeriesScope = "ThisInstance",
): Command {
  return { Edit: { id, patch, scope } };
}

export function recurrenceCommand(
  id: TaskId,
  recurrence: RecurrenceSpec | "Stop",
  extra: TaskPatch = {},
): Command {
  const update = recurrence === "Stop" ? "Stop" : { Set: recurrence };
  return editCommand(id, { ...extra, recurrence: update }, "ThisAndFuture");
}

export function createCommand(fields: NewTask): Command {
  return { Create: { id: newId(), fields } };
}
